import { render, staticRenderFns } from "./DialogEditarPago.vue?vue&type=template&id=05f8b52c&"
import script from "./DialogEditarPago.vue?vue&type=script&lang=js&"
export * from "./DialogEditarPago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports